import React from "react";
import PropTypes from "prop-types";

import classes from "./beforeloginheader.module.css";
import { Col, Container, Row } from "react-bootstrap";
import {
  ArrowUpRightBlue,
  BackwardArrow,
  logo,
} from "../../constant/imagePath";
import Colors from "../assets/Colors";
import Fonts from "../assets/Fonts";
import { LinkButtonWithIcon } from "../LinkButtonWithIcon/LinkButtonWithIcon";
import { ReactSVG } from "react-svg";

export const BeforeLoginHeader = ({
  onClick,
  icon,
  text1,
  text2,
  goBackOnClick,
  text1Style,
  customStyle,
  wrapperStyle,
  ...props
}) => (
  <Container
    className="fluid beforeLoginHeader"
    style={{
      position: "absolute",
      background: "transparent",
      maxWidth: "100%",
      ...customStyle,
    }}
  >
    <Row
      className={`${[classes.wrapper].join(" ")}`}
      style={{ ...wrapperStyle }}
    >
      <Col md={6} className={classes.logoContainer}>
        <ReactSVG
          src={icon}
          beforeInjection={(svg) => {
            svg.classList.add(classes.logoImage);
          }}
        />
      </Col>
      {onClick && (
        <Col md={6}>
          <Row>
            {goBackOnClick && (
              <Col md={4} className={classes.goBackLink}>
                <LinkButtonWithIcon
                  primary={false}
                  leftIcon={BackwardArrow}
                  text={"Go back"}
                  iconStyle={{ marginRight: "16px" }}
                  onClick={goBackOnClick}
                  customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
                />
              </Col>
            )}

            <Col md={goBackOnClick ? 8 : 12}>
              <div className={`${[classes.linkContainer].join(" ")}`}>
                <span
                  style={{
                    ...text1Style,
                    ...Fonts.p2,
                    color: Colors.neutralShadesOfDimGray,
                  }}
                >
                  {text1}
                </span>
                <LinkButtonWithIcon
                  rightIcon={ArrowUpRightBlue}
                  primary={true}
                  text={text2}
                  iconStyle={{ margin: "0px", width: "16px", height: "16px" }}
                  onClick={onClick}
                  customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
                />
              </div>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  </Container>
);

BeforeLoginHeader.propTypes = {
  icon: PropTypes.string,
  text1: PropTypes.string,
  text2: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  goBackOnClick: PropTypes.func,
  text1Style: PropTypes.object,
};

BeforeLoginHeader.defaultProps = {
  icon: logo,
  text1: "Don’t have an account?",
  text2: "Get started",
};
